import { SvgIcon, SvgIconProps } from "@mui/material";
import type { JSX } from "react";

export const CommercialItemIcon = (props: SvgIconProps): JSX.Element => (
  <SvgIcon viewBox="0 0 27 28" fill="none" {...props}>
    <path
      d="M17 15.0191C16.3373 14.3856 15.4594 14 14.5012 14C12.4299 14 10.7516 15.7904 10.7516 18C10.7516 20.2096 12.4299 22 14.5012 22C15.4623 22 16.3373 21.6144 17 20.9809M10 19.1997H13.7496M10 16.8003H13.7496"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />

    <path
      d="M24.9942 10.6777H3.50776C3.22787 10.6777 3.00098 10.891 3.00098 11.154V24.2015C3.00098 24.4645 3.22787 24.6777 3.50776 24.6777H24.9942C25.2741 24.6777 25.501 24.4645 25.501 24.2015V11.154C25.501 10.891 25.2741 10.6777 24.9942 10.6777Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />

    <path
      d="M14.5127 4.96478C15.4593 4.96478 16.2267 4.20184 16.2267 3.26071C16.2267 2.31958 15.4593 1.55664 14.5127 1.55664C13.5662 1.55664 12.7988 2.31958 12.7988 3.26071C12.7988 4.20184 13.5662 4.96478 14.5127 4.96478Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      fill="none"
    />

    <path
      d="M13.1626 4.59375C11.5248 6.39751 9.88698 8.19948 8.25098 10.0032"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />

    <path
      d="M15.9766 4.59375C17.6144 6.39751 19.2522 8.19948 20.8882 10.0032"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </SvgIcon>
);
